import React from 'react'
import { GrDown } from "react-icons/gr";
export default function DownButton (props) {
  return (
    <div className='flex items-center justify-center'>
      <button
        {...props}
        className='transition-all duration-700 inline-flex absolute rounded-full p-8 items-center justify-center group/spinner z-0 cursor-pointer'
      >
        <GrDown size={'16px'} className='relative z-20' />
        <span className='absolute transition-all duration-500 rounded-full w-[48px] h-[48px] z-10 group-hover/btn:animate-spin-slow border-2 border-dotted border-white group-hover/spinner:border-black'></span>
        <span className='absolute transition-all duration-500 rounded-full group-hover/spinner:w-full group-hover/spinner:h-full w-[32px] h-[32px] z-0 bg-white/50 group-hover/spinner:bg-white'></span>
      </button>
    </div>
  )
}
